"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseAddressFromNodeId = exports.generateMnemonicFromAddress = void 0;

var hdnode_1 = require("@ethersproject/hdnode");
/**
 * @param address - valid eth address with leading 0x
 */


var generateMnemonicFromAddress = function generateMnemonicFromAddress(address) {
  var prefixedAddress = typeof address === 'string' && !address.startsWith('0x') ? "0x".concat(address) : address;
  return (0, hdnode_1.entropyToMnemonic)(prefixedAddress).split(' ').slice(0, 3).map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(' ');
};

exports.generateMnemonicFromAddress = generateMnemonicFromAddress;
/**
 * @param id - node id
 */

var parseAddressFromNodeId = function parseAddressFromNodeId(id) {
  var hashPos = id.indexOf('#');

  if (hashPos < 0) {
    return id;
  }

  return id.slice(0, hashPos);
};

exports.parseAddressFromNodeId = parseAddressFromNodeId;